import { PERMISSIONS } from '@navicosa/shared-types';
import { useQuery } from '@tanstack/react-query';
import { Alert, Card, Col, Row, Statistic, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import type { DashboardSummary } from '../api/types';
import { useAuth } from '../auth/AuthContext';

/**
 * Tổng quan – chỉ số có dữ liệu thật (PRD 6.2). Không tính "doanh thu" từ yêu cầu hay báo giá
 * chưa chốt; module ghi nhận doanh thu chưa có trong MVP.
 */
export function DashboardPage() {
  const { me, can } = useAuth();
  const nav = useNavigate();
  const q = useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api.get<DashboardSummary>('/admin/dashboard/summary'),
    enabled: can(PERMISSIONS.REQUESTS_READ),
    refetchInterval: 60_000,
  });
  const d = q.data;
  const cards: { title: string; value?: number; to: string; show: boolean }[] = [
    {
      title: 'Yêu cầu mới chờ tiếp nhận',
      value: d?.requests_pending,
      to: '/requests?status=pending',
      show: can(PERMISSIONS.REQUESTS_READ),
    },
    {
      title: 'Yêu cầu đang xử lý',
      value: d?.requests_processing,
      to: '/requests?status=processing',
      show: can(PERMISSIONS.REQUESTS_READ),
    },
    {
      title: 'Báo giá nháp',
      value: d?.quotations_draft,
      to: '/quotations?status=draft',
      show: can(PERMISSIONS.QUOTATIONS_READ),
    },
    {
      title: 'Báo giá chờ khách phản hồi',
      value: d?.quotations_waiting_customer,
      to: '/quotations?status=sent',
      show: can(PERMISSIONS.QUOTATIONS_READ),
    },
    {
      title: 'Đơn thuê đang thực hiện',
      value: d?.bookings_in_progress,
      to: '/bookings',
      show: can(PERMISSIONS.BOOKINGS_READ),
    },
    {
      title: 'Sản phẩm đang hiển thị',
      value: d?.products_published,
      to: '/products?status=published',
      show: can(PERMISSIONS.CATALOG_READ),
    },
    {
      title: 'Xe thực tế',
      value: d?.equipment_units,
      to: '/equipment',
      show: can(PERMISSIONS.EQUIPMENT_READ),
    },
  ];

  return (
    <>
      <Typography.Title level={3}>Xin chào, {me?.full_name}</Typography.Title>
      <Row gutter={[16, 16]}>
        {cards
          .filter((c) => c.show)
          .map((c) => (
            <Col key={c.title} xs={24} sm={12} lg={8} xl={6}>
              <Card hoverable onClick={() => nav(c.to)}>
                <Statistic title={c.title} value={c.value ?? 0} loading={q.isLoading} />
              </Card>
            </Col>
          ))}
      </Row>
      <Alert
        style={{ marginTop: 24 }}
        type="info"
        showIcon
        message="Chỉ đếm số lượng. Hệ thống không tính doanh thu từ yêu cầu hay báo giá chưa chốt (PRD 6.2)."
      />
    </>
  );
}
